import { createAction } from '@reduxjs/toolkit';

import { SupportActions  } from "../constants/support";
import { ActionSuffixes } from "../constants/common/actions";

import IResyncUserRequest from '../types/support/IResyncUserRequest';
import IReportUserRequest from '../types/support/IReportUserRequest';

export const createGetReportAction = () => createAction<IReportUserRequest>(SupportActions.GetReport);
export const createSetReportAction = () => createAction(SupportActions.Report + ActionSuffixes._Set,
	(value: any) => ({ meta: { prefix: SupportActions.Report }, payload: value }));

export const createResyncUserAction = () => createAction<IResyncUserRequest>(SupportActions.ResyncUser);

export const createIsReportLoadingAction = () => createAction(SupportActions.IsReportLoading + ActionSuffixes._Set,
	(value: boolean) => ({ meta: { prefix: SupportActions.IsReportLoading }, payload: value }));
	
export const createIsResyncUserLoadingAction = () => createAction(SupportActions.IsResyncUserLoading + ActionSuffixes._Set,
	(value: boolean) => ({ meta: { prefix: SupportActions.IsResyncUserLoading }, payload: value }));
	

